import { render, staticRenderFns } from "./AddPolice.vue?vue&type=template&id=21e549d8"
import script from "./AddPolice.vue?vue&type=script&lang=js"
export * from "./AddPolice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports